import React, { useState } from "react";
import { Box, Typography, Rating, Button, Modal } from "@mui/material";
import color from "../utils/Colors";
import { useParams } from "react-router-dom";
import { useUser } from "../../services/Context/UserContext";
import { createUserRating } from "../../services/services";
import { useSnackbar } from "../utils/SnackBar";

interface RatingModalProps {
  open: boolean;
  handleClose: () => void;
}

const RatingModal: React.FC<RatingModalProps> = ({ open, handleClose }) => {
  const [value, setValue] = useState<number | null>(4);
  const { user } = useUser();
  const { courseId } = useParams<{ courseId: string }>();
  const showSnackbar = useSnackbar();

  const handleSubmit = async () => {
    if (!value) {
      showSnackbar("Please select a rating", "warning");
      return;
    }
    if (!user?.id) {
      showSnackbar("You must be logged in to rate a course", "error");
      return;
    }
    if (!courseId) {
      showSnackbar("Course ID is missing", "error");
      return;
    }

    try {
      const payload = {
        rating: Math.round(value),
        feedback: JSON.stringify({
          authorName: user.name || "Student",
          text: `Rated ${value} stars via modal`,
        }),
        feedbackType: `course_${courseId}`,
        userId: user.id,
      };
      await createUserRating(payload);
      showSnackbar("Rating submitted successfully!", "success");
      handleClose();
    } catch (error: any) {
      console.error("Error submitting rating:", error);
      showSnackbar(
        error?.response?.data?.message || "Failed to submit rating",
        "error",
      );
    }
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        // minHeight="100vh"
        bgcolor="white"
        p={3}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          margin: "auto",
          boxShadow: 24,
          borderRadius: 2,
        }}
      >
        <Typography
          variant="h5"
          gutterBottom
          sx={{ color: color.textColor, fontWeight: "bold", mb: 4 }}
        >
          How would you rate this course?
        </Typography>
        {/* <Typography variant="body1" sx={{ mb: 2,color:color.textColor,mt:1 }}>
          Select rating
        </Typography> */}
        <Rating
          name="course-rating"
          value={value}
          precision={1}
          onChange={(event, newValue) => {
            setValue(newValue);
          }}
          size="large"
          sx={{ color: color.firstColor }}
        />

        <Button
          id="button"
          variant="contained"
          onClick={handleSubmit}
          sx={{
            marginTop: 4,
            ml: "auto",
            backgroundColor: color.firstColor,
            color: "white",
          }}
        >
          Submit
        </Button>
      </Box>
    </Modal>
  );
};

export default RatingModal;
